import { render, staticRenderFns } from "./DeclarationOfConformityTable.vue?vue&type=template&id=30151f95&"
import script from "./DeclarationOfConformityTable.vue?vue&type=script&lang=js&"
export * from "./DeclarationOfConformityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports